import React, { useEffect, useState } from "react";
// import Profile from "./HomeCards/Profile";
// import LeaveSummary from "./HomeCards/LeaveSummary/LeaveSummary";
// import LeaveRequest from "./HomeCards/LeaveRequest/LeaveRequest";
// import MyTask from "./HomeCards/MyTask/MyTask";
// import UpcomingBirthday from "./HomeCards/Birthdays/UpcomingBirthday";
import "./Home.css";
import AdminCard from "../HomeComponents/AdminCard";
import LeaveSummary from "../HomeComponents/LeaveSummary";
import LeaveComparison from "../HomeComponents/LeaveComparison";
import Attendance from "../HomeComponents/Attendance";
import BirthDay from "../HomeComponents/BirthDay";
import EmpOnLeave from "../HomeComponents/EmpOnLeave";
import Approvals from "../HomeComponents/Approvals";
import AttendanceOverview from "../HomeComponents/AttendanceOverview";
import TaskForMe from "../HomeComponents/TaskForMe";
import QuickLink from "../HomeComponents/QuickLink";
import PendingJobs from "../HomeComponents/PendingJobs";
import WorkAnniversary from "../HomeComponents/WorkAnniversary";
import NewHires from "../HomeComponents/NewHires";
import SpecialAlerts from "../HomeComponents/SpecialAlerts";
import EmployeeJobStatus from "../HomeComponents/EmployeeJobStatus";
import RequestCard from "../HomeComponents/RequestCard";
import CalendarHome from "../HomeComponents/CalendarHome";
import CalendarHomeTest from "../HomeComponents/CalendarHomeTest";
import JobStatus from "../HomeComponents/JobStatus";
import AttendanceNew from "../HomeComponents/AttendanceNew";
import EmployeeDetails from "../HomeComponents/EmployeeDetails";
import EmployeeEvents from "../HomeComponents/EmployeeEvents";
import PendingLeave from "../HomeComponents/PendingLeave";
import TaskStatusChart from "../HomeComponents/TaskStatusChart";
import ExpiryCount from "../HomeComponents/ExpiryCount";
import FullEmployeeListWithAttendance from "../HomeComponents/FullEmployeeListWithAttendance";
import TaskNewCard3 from "../HomeComponents/TaskNewCard3";
import JobStatus2 from "../HomeComponents/JobStatus2";
import JobStatus3 from "../HomeComponents/JobStatus3";
import AttendanceBubbleChart from "./AttendanceBubbleChart";
import axios from "axios";

const Home = () => {
  const [eventFilterData, setEventFilterData] = useState(null);

  useEffect(() => {
    const isFreshLogin = localStorage.getItem("isFreshLogin");

    if (isFreshLogin === "true") {
      // Remove the flag from localStorage
      localStorage.removeItem("isFreshLogin");

      // Refresh the page
      window.location.reload();
    }

    handleGetPortNo();
  }, []);

  const [portNoData, setPortNoData] = useState();

  const handleGetPortNo = async () => {
    const storedUserDataArray = localStorage.getItem("BondTimeuserDataArray");
    const parsedUserDataArray = JSON.parse(storedUserDataArray) || [];

    // setUserDataArrayState(parsedUserDataArray)

    try {
      const response = await axios.get(
        `https://cubixweberp.com:301/api/clientmanager/${parsedUserDataArray[0].cmpcode}`
      );
      if (response.status === 200) {
        console.log("response.data::", response.data);
        console.log("response.data2::", response?.data[0].IMG_SERVERPATH);
        localStorage.setItem(
          "PostEmpImagePath",
          JSON.stringify(response?.data[0].IMG_SERVERPATH)
        );
        // setPortNoData(response.data);
        // setPortNoData(response.data?[0].IMG_SERVERPATH);
      }
    } catch (error) {
      console.log("handleGetPortNo", error);
    }
  };

  console.log("eventFilterData", eventFilterData);

  return (
    <div className="flex flex-col  items-center min-h-screen bg-[#F3F2FA]">
    {/* <div className="flex flex-col justify-center items-center min-h-screen bg-[#DEDEDE]"> */}
      <div className="w-full p-1 grid gap-4 grid-cols-11 auto-rows-auto grid-flow-dense pb-10">
        {/* EJSCard */}

        {/* <div className="border rounded-2xl mb-5  col-span-4  h-[305px] pb-5 overflow-y-scroll hover:overflow-y-scroll hover:scrollbar-thin hover:scroll-smooth scrollbar-none  scrollbar-thumb-gray-200 scrollbar-track-transparent"> */}
        {/* <div className="border   col-span-4    overflow-y-scroll hover:overflow-y-scroll hover:scrollbar-thin hover:scroll-smooth scrollbar-none  scrollbar-thumb-gray-200 scrollbar-track-transparent"> */}
        <div className="    col-span-4   overflow-y-scroll hover:overflow-y-scroll">
              <CalendarHomeTest
                eventFilterData={eventFilterData}
                setEventFilterData={setEventFilterData}
              />
        </div>

        {/* <div className="col-span-3 max-h-[450px] pb-5 overflow-y-scroll hover:overflow-y-scroll hover:scrollbar-thin hover:scroll-smooth scrollbar-none  scrollbar-thumb-gray-200 scrollbar-track-transparent"> */}
        <div className="col-span-2 ">
          <AttendanceBubbleChart />
        </div>

        <div className="col-span-3  rounded-2xl ">
          <div className="flex flex-col  justify-start items-center">
            <div>
              <LeaveSummary />
            </div>
            <div className="grid grid-cols-2 ">
              <div className="mr-6  flex justify-center items-center w-full"></div>
              <div className="ml-6  flex justify-center items-center">
                <JobStatus2 />
              </div>
            </div>
          </div>
        </div>

        <div className=" col-span-2 rounded-2xl flex flex-col justify-start items-center ">
          <div>
            <ExpiryCount />
          </div>
        </div>

        {/* ReqCard */}
        <div className="col-span-7 rounded-2xl bg-white   row-span-8 shadow-md">
          <RequestCard />
        </div>

        {/* DashNewTaskCard */}
        {/* <div className="col-span-11 rounded-2xl bg-white   shadow-md">
          <TaskNewCard3 />
        </div> */}

        {/* <div className="col-span-5 bg-white rounded-2xl h-[220px]  shadow-md row-span-4  p-1 overflow-y-auto">
          <LeaveComparison />
        </div> */}

        {/* DashQuickLink */}
        <div className="col-span-4 rounded-2xl overflow-y-auto bg-white row-span-  shadow-md  row-span-4 ">
          <QuickLink />
        </div>

        {/* DashAdminCard */}
        {/* <div className="col-span-11 bg-white rounded-2xl mb-12 shadow-md ">
          <EmployeeDetails />
        </div> */}
      </div>
    </div>
  );
};

export default Home;
